export default function(urlVal){
    let url = urlVal||window.location.href;//获取整个url
    let params = {};
    let queryString = url.split('?')[1];
    if (queryString) {
        let pairs = queryString.split('&');
        pairs.forEach(pair => {
            let keyValues = pair.split('=');
            let key = decodeURIComponent(keyValues[0]);
            let value = decodeURIComponent(keyValues.slice(1).join('='));
            if (params[key]) {
                if (!Array.isArray(params[key])) {
                    params[key] = [params[key]];
                }
                params[key].push(value);
            } else {
                params[key] = value;
            }
        });
    }
    let hashIndex = url.indexOf('#');
    if (hashIndex !== -1) {
        let hashValue = url.substring(hashIndex + 1);
        if (hashValue.includes('=')) {
            let hashParams = hashValue.split('&');
            hashParams.forEach(param => {
                let keyValues = param.split('=');
                let key = decodeURIComponent(keyValues[0]);
                let value = decodeURIComponent(keyValues.slice(1).join('='));
                params[key] = value;
            });
        } else {
            params['hash'] = hashValue;
        };
    };
    return params;
};


// WEBPACK FOOTER //
// ./src/vuex/urlVal.js